export enum ViewUI {
  AnatomyLabels = 'anatomyLabels', // Anatomy node context label
  Audio = 'audio', // Audio start / stop
  Camera = 'camera', // Camera controls - zoom, pan, reset
  Column = 'column', // Left description panel, visible on desktop mode
  ColumnToggle = 'column-toggle', // Left description panel, visible on desktop mode
  ContextActions = 'contextActions', // Individual actions performed on a structure
  Description = 'description', // Content description
  Drawer = 'drawer', // Bottom description panel, visible at 960 below
  Fullscreen = 'fullscreen', // Fullscreen / Open in new tab button
  Help = 'help', // Help button
  InternetExplorerWarning = 'internetExplorerWarning', // Internet explorer warning
  LabelList = 'labelList', // List of labels in column
  Labels = 'labels', // Regular labels
  Layout = 'layout', // Layout
  Legend = 'legend', // Content legend
  Loader = 'loader', // Loader
  Logo = 'logo', // BioDigital logo
  Media = 'media', // Play, pause, scrubber
  Mediabar = 'mediabar', // Free floating play, pause, scrubber, audio controls
  Menu = 'menu', // Primary menu button
  NodeInfo = 'nodeInfo', // Wikipedia descriptions
  Pagination = 'pagination', // Pagination controls
  Presenter = 'presenter', // Presenter button
  Reset = 'reset', // Reset button and undo functionality
  Search = 'search', // Search (anatomy tree) button
  ScrubberButton = 'scrubberButton', // Scrubber button in main toolbar
  ScrubberItem = 'scrubberItem', // Scrubber button in menu
  TitleOnly = 'title-only', // Floating title in top left
  ToggleLabels = 'toggleLabels', // Toggle labels on and off
  Toolbar = 'toolbar', // Interaction tools, visible in drawer when responsive, floating on the scene in desktop
  Tools = 'tools', // Tool bar button in menu
  Tutorial = 'tutorial', // Getting started tour
  Undo = 'undo', // Undo (alias)
  VisibilityLayers = 'visibilityLayers', // Layer slider
  Whiteboard = 'whiteboard', // Draw tool
}
